import React from "react";
import Select from "Components/common/Select/Select";

class Field extends React.Component {
    constructor(props) {
        super(props);
        
        this.fieldRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if(!_.isEqual(nextProps.field.value, this.props.field.value) && nextProps.isTyping) {
            (this.fieldRef.current || {}).value = (nextProps.field.value || "");
        }

        return true;
    }

    render() {
        const { field } = this.props;

        if(this.props.userType === "new" || field.retainedField || !this.props.userType) {
            return (
                <div class={`formContainer ${this.props.isDisabled ? "disabled" : ""}`}>
                    <label>{field.required && <sup>*</sup>} {field.label}</label>
                    {field.type === "display" && <span>{field.value}</span>}
                    {field.type === "select" && (
                        <Select 
                            classes={{...field.classes}}
                            selected={field.value}
                            options={field.options}
                            onChange={field.onChange}
                        />
                    )}
                    {field.type === "text" && (
                        <React.Fragment>
                            {((field.retainedField && this.props.userType === "existing" && this.props.isExistingSelected) || (field.retainedField && this.props.userType !== "existing") || !field.retainedField) && (
                                <input 
                                    type="text" 
                                    placeholder="Type here"
                                    class={`${field.hasError ? "hasError" : ""}`}
                                    onChange={field.onChange} 
                                    ref={this.fieldRef}
                                />
                            )}
                            {(field.retainedField && this.props.userType === "existing" && !this.props.isExistingSelected) && (
                                <span>--</span>
                            )}
                        </React.Fragment>
                    )}
                    {field.hasError && <span class="errorMsg">{field.errorMessage}</span>}
                </div>
            );
        }

        return (
            <div class={`formContainer ${this.props.isDisabled ? "disabled" : ""}`}>
                <label>{field.required && <sup>*</sup>} {field.label}</label>
                <span>{field.value && this.props.isExistingSelected ? (field.value.label ? field.value.label : field.value) : "--"}</span>
            </div>
        )
    }
}

export default Field;
